import { render } from "./RiwayatPembayaranView.vue?vue&type=template&id=3c0f9dfb&scoped=true"
import script from "./RiwayatPembayaranView.vue?vue&type=script&lang=js"
export * from "./RiwayatPembayaranView.vue?vue&type=script&lang=js"

import "./RiwayatPembayaranView.vue?vue&type=style&index=0&id=3c0f9dfb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0f9dfb"]])

export default __exports__